// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"e6eb2410","399":"9a729b62","404":"ddbd6cce","453":"1f0db8ff","721":"bad5f41a","780":"ca09b86b","787":"532eed27"}[chunkId] + ".chunk.js";
};